import React from "react";
import { Search, Filter } from "lucide-react";

interface TableFiltersProps {
  searchTerm?: string;
  onSearchChange?: (value: string) => void;
  placeholder?: string;
  children?: React.ReactNode;
  className?: string;
}

export const TableFilters: React.FC<TableFiltersProps> = ({
  searchTerm,
  onSearchChange,
  placeholder = "Search...",
  children,
  className = "",
}) => {
  return (
    <div className={`flex flex-col md:flex-row items-center gap-4 px-6 py-4 bg-card border border-secondary/20 rounded-2xl shadow-sm ${className}`}>
      {/* Search Section */}
      <div className="relative flex-1 group min-w-0 w-full md:w-auto">
        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-10 flex items-center justify-center pointer-events-none">
          <Search className="w-4 h-4 text-muted-foreground/60 transition-colors group-focus-within:text-primary" />
        </div>
        <input
          type="text"
          placeholder={placeholder}
          className="h-10 w-full bg-transparent pl-10 pr-4 text-sm font-medium focus:outline-none placeholder:text-muted-foreground/40 transition-all border-none"
          value={searchTerm}
          onChange={(e) => onSearchChange?.(e.target.value)}
        />
        <div className="absolute bottom-0 left-10 right-4 h-[1px] bg-secondary/20 group-focus-within:bg-primary/40 transition-colors" />
      </div>

      {children && (
        <>
          {/* Vertical Divider for Desktop */}
          <div className="hidden md:block h-8 w-[1px] bg-secondary/20 mx-2" />
          
          {/* Filters Section */}
          <div className="flex items-center gap-4 w-full md:w-auto">
            <div className="flex items-center gap-2 text-muted-foreground/60 px-2">
              <Filter className="w-3.5 h-3.5" />
              <span className="text-[10px] font-black uppercase tracking-widest hidden lg:block">Filters</span>
            </div>
            <div className="flex items-center gap-3 flex-1 md:flex-none justify-end">
              {children}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
